import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { TeacherProfile } from '../../../api/models/teacher-profile';

@Component({
  selector: 'app-teacher-top-panel',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (getSchoolName()) {
      <p class="text-muted">{{getSchoolName()}}</p>
    }
  `,
})
export class TeacherTopPanelComponent {
  profile = input.required<TeacherProfile>();

  getSchoolName(): string {
    return this.profile()?.schools?.[0]?.name || '';
  }
}
